import { webportalUrl, currentTheme } from '@/../appConfig';
import { WebPortal } from '@/models/WebPortal';
import { defineStore } from 'pinia'
import { config } from '@/api/config';
import axios from 'axios';

//Import required pinia stores
import { useLaundryStore } from './laundry';

import locale from '@/localeConfig';

export const useWebportalStore = defineStore('webportal', {
    state: () => ({
        webportals: [] as WebPortal[],
        selectedWebportal: (JSON.parse(localStorage.getItem('webportal') || '{}') ?? null) as WebPortal,
        version: localStorage.getItem('version'),
        vlApiVersion: localStorage.getItem('vlApiVersion'),
        lockWebportal: false
    }),
    actions: {
        async getWebPortals() {
            //Reset webportals
            this.webportals = [];
            
            if (webportalUrl) {
                this.selectedWebportal = {
                    "Naam": currentTheme as string,
                    "ServiceUrl": webportalUrl
                } as WebPortal
                this.webportals.unshift(this.selectedWebportal)
                localStorage.setItem('webportal', JSON.stringify(this.selectedWebportal));
                return
            }

            //Get webportals from webportalCentraal
            try {
                const response = await axios.post(`${config.webportalCentraalURL}/GetWebportals`, { appID: 2 });
                // eslint-disable-next-line
                this.webportals = response.data.d.map(({ __type, ...rest }: { __type: string }) => rest)
                // this.webportals = response.data.d.map(({ __type, ...rest }: { __type: string }) => rest).map((p: any) => {
                //     const match = p.ServiceUrl?.match(/(?:https:\/\/)(.*)\.(?:.*)\.net/)
                //     if (match?.length && match.length > 1) {
                //         p.ServiceUrl = p.ServiceUrl.replace(match[1], match[1] + 'sim')
                //     }
                //     return p
                // });
            } catch (error: any) {
                console.error(error);
            } finally {
                //add debug portal to localhosts
                if(process.env.NODE_ENV == 'development'){
                    this.webportals.unshift({ Naam: 'localhost debug', ServiceUrl: config.debugServicesUrl, vlApiUrl: config.debugVlApiUrl, virtwassWebUrl: config.debugVirtwassWebUrl });
                }

                // refresh currently set webportal
                if (this.selectedWebportal?.Naam) {
                    const webportal = this.webportals.find((w) => w.Naam && w.Naam === this.selectedWebportal.Naam) ?? null
                    if (webportal) {
                        this.selectedWebportal = webportal
                        localStorage.setItem('webportal', JSON.stringify(webportal));
                    }
                }

                const currentWebportal = this.webportals.find(w => w.ServiceUrl.startsWith(window.location.origin));
                if (currentWebportal) {
                    this.lockWebportal = true;
                    this.setWebPortal(currentWebportal.Naam);
                }
                else {
                    this.lockWebportal = false;
                }
            }
        },

        setWebPortal(name: string) {
            if (webportalUrl) {
                return;
            }
            //Get webportal out of webportals by name
            this.webportals.forEach((portal) => {
                //Set selected portal and add to localStorage as stringified object
                if (portal.Naam === name) {
                    this.selectedWebportal = portal;
                    localStorage.setItem('webportal', JSON.stringify(portal));
                }
            })
        }
    },
    getters: {
        vlApiUrl: (state) => {
            //For debug
            if(state.selectedWebportal?.vlApiUrl){
                return state.selectedWebportal.vlApiUrl + locale.locale;
            }

            const laundryStore = useLaundryStore();
            if(laundryStore.currentLaundry.NrWasserij != 37){
                return `https://vlapivl${laundryStore.currentLaundry.NrWasserij}.virtuallaundry.net/1.0/` + locale.locale;
                //return `https://vlapivlsim${laundryStore.currentLaundry.NrWasserij}.virtuallaundry.net/1.0/` + (localStorage.getItem('language') || defaultLanguage);
            }
            else{
                return 'https://vlapivl37t.virtuallaundry.net/1.0/' + locale.locale;
            }
        },
        virtwassUrl: (state) => {
            //For debug
            if(state.selectedWebportal?.virtwassWebUrl){
                return state.selectedWebportal.virtwassWebUrl;
            }

            const laundryStore = useLaundryStore();
            if(laundryStore.currentLaundry.NrWasserij != 37){
                return `https://vl${laundryStore.currentLaundry.NrWasserij}virtwass.virtuallaundry.net/`;
                //return `https://vlsim${laundryStore.currentLaundry.NrWasserij}virtwass.virtuallaundry.net/`;
            }
            else{
                return 'https://vl37tvirtwass.virtuallaundry.net/';
            }
        }
    }
})